import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from '../../utils/grid/Grid';
import LandingpageTeaser from './LandingpageTeaser';

function renderLandingpageTeaser(index, teaserItem, bigTeaser) {
  return (
    <Col xs={12} sm={6} md={bigTeaser ? 6 : 3} key={index}>
      <LandingpageTeaser {...teaserItem} bigTeaser={bigTeaser} />
    </Col>
  );
}

const isBigTeaser = (index) => !(index % 7 && (index - 1) % 7);

const LandingpageTeaserList = ({ teaser }) => (
  <Row bottom="xs">
    {teaser.map((teaserItem, index) => {
      const bigTeaser = isBigTeaser(index);
      return renderLandingpageTeaser(index, teaserItem, bigTeaser);
    })}
  </Row>
);

LandingpageTeaserList.propTypes = {
  teaser: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export default LandingpageTeaserList;
